import {
  runOverrideSectionSubmit,
  type OverrideSectionSubmitArgs,
} from './runOverrideSectionSubmit';

export async function executeOverrideSubmit(
  canSubmit: boolean,
  submitArgs: OverrideSectionSubmitArgs,
  callbacks: {
    onClose: () => void;
    onVendorCandidatesError: () => void;
  },
): Promise<void> {
  if (!canSubmit) return;
  try {
    const result = await runOverrideSectionSubmit(submitArgs);
    if (result.kind === 'close') callbacks.onClose();
  } catch {
    callbacks.onVendorCandidatesError();
  }
}
